(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'stringControl',
            [
                'CHROME',
                StringControlFactory
            ]
        );

    // Factory Method
    function StringControlFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.PROJECT.CONTROL.STRING + CHROME.POSTFIX
        };

    }
})();



